module.exports = __webpack_public_path__ + "img/self-help.f8ccecf0.jpg";